import axios from "axios";

const NFAI_Restoration_SmartflowServices = {
    smartTrackerTitleFilter:() => axios.get(`/NFAIRestoration/smartTrackerTitleFilter`),
    smartTrackerReelFilter:(titleName:string) => axios.get(`/NFAIRestoration/smartTrackerReelFilter?titleName=${titleName}`),
    smartTrackerEmployeeIdFilter:() => axios.get(`/NFAIRestoration/smartTrackerEmployeeIdFilter`),
    smartTrackerEmployeeNameFilter:() => axios.get(`/NFAIRestoration/smartTrackerEmployeeNameFilter`),
    NFAISmartTracker:(pageNo:number,params:any) => axios.post(`/NFAIRestoration/NFAISmartTracker?pageNo=${pageNo}&pageSize=20`, params),
    nfaiSmartTrackerCount:(params:any) => axios.post(`/NFAIRestoration/nfaiSmartTrackerCount`, params),
    nfaicutliststatusUpdate:(itemId:string, subtaskName:string, actionerName:string)=> axios.get(`/NFAIRestoration/nfaicutliststatusUpdate?id=${itemId}&currentsubTask=${subtaskName}&actionName=${actionerName}`),
    honeyCombStatusReport:() => axios.get(`/NFAIRestoration/NFAIHoneyCombStatusReport`),
}
export default NFAI_Restoration_SmartflowServices;